class ThrottleMessage {
    constructor() {
    }

    show() {
        this.throttleElement = document.querySelector('.throttle');
        if (this.throttleElement) {
            this.throttleElement.classList.add('is-shown');        
        }
    }

    hide() {
        this.throttleElement = document.querySelector('.throttle');
        if (this.throttleElement && this.throttleElement.classList.contains('is-shown'))
        {
            this.throttleElement.classList.remove('is-shown');
        }         
    }
}

const instance = new ThrottleMessage();
export default instance;